import { Check } from "lucide-react";
import { Chapter, MaskedLine, Reveal } from "../components/motion";
import BookMockup from "../components/BookMockup";
import CtaButton from "../components/CtaButton";
import { config } from "../config/siteConfig";

const Offer = () => (
  <section
    id="get-the-book"
    data-testid="offer-section"
    className="relative bg-[#08162B] text-white py-24 lg:py-36 overflow-hidden"
  >
    <div className="absolute inset-0 hero-grid pointer-events-none" />
    <div className="hidden lg:block absolute -bottom-40 left-[-10%] w-[50vw] h-[50vw] rounded-full bg-[#12294D] blur-[140px] opacity-70 pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="08" label="The Offer" dark />

      <div className="mt-14 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <div className="lg:col-span-5 flex justify-center lg:justify-start">
          <div className="scale-[0.82] sm:scale-90 origin-center">
            <BookMockup />
          </div>
        </div>

        <div className="lg:col-span-7">
          <h2 className="font-display tracking-[0.02em] leading-[1.05] text-[clamp(1.9rem,4.5vw,3.5rem)] max-w-2xl">
            <MaskedLine delay={0.1}>
              STOP TRYING TO BUILD YOUR BUSINESS FROM 1,000 DIFFERENT VIDEOS.
            </MaskedLine>
          </h2>
          <Reveal delay={0.25} className="mt-5">
            <p className="font-condensed font-light text-xl sm:text-2xl text-white/60">
              Put the blueprint in front of you.
            </p>
          </Reveal>

          <Reveal delay={0.3} className="mt-10">
            <div className="border border-white/15 bg-white/[0.03] p-7 sm:p-10">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
                Inside The Ecom Bible
              </p>
              <ul className="mt-7 grid sm:grid-cols-2 gap-x-8 gap-y-4" data-testid="value-stack">
                {config.valueStack.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <Check size={16} strokeWidth={3} className="mt-0.5 shrink-0 text-[#D4AF37]" />
                    <span className="text-lg sm:text-xl text-white/80">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.4} className="mt-10 flex flex-wrap items-center gap-6">
            <CtaButton variant="gold" testid="offer-cta-button" />
            <div>
              {config.book.price && (
                <p data-testid="offer-price" className="font-display text-4xl">{config.book.price}</p>
              )}
              <p className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-white/40">
                {config.book.note}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Offer;
